var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCtsi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.748 11.143a.55.55 0 0 0-.515-.356h-5.276l-3.16-8.431a.55.55 0 0 0-.919-.177l-7.856 8.608H2.55a.55.55 0 0 0-.515.741l3.296 8.788a.55.55 0 0 0 .515.356h5.2L14.544 30l5.274-5.77 3.24-3.556h5.47a.55.55 0 0 0 .515-.74l-3.294-8.79zm-9.666-7.559 2.847 7.59-3.185 3.465-1.31-3.498a.55.55 0 0 0-.514-.356H9.508l6.575-7.202zm-12.74 8.304H13.54l1.37 3.655-3.704 4.031h-4.98l-2.883-7.686zm15.664 11.598-4.062 4.446-2.877-7.672 3.272-3.566 1.353 3.62a.55.55 0 0 0 .514.357h4.366l-2.567 2.816zm-1.412-3.914-1.42-3.785 3.587-3.905h5.092l2.884 7.69H17.594z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtsi);
export default __webpack_public_path__ + "static/media/CTSI.0694c2e08e8ed49f327b4022572ae58e.svg";
export { ForwardRef as ReactComponent };